import React from 'react'
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';


function TerminationTools() {
    // const [active, setActive] = useState("Safe Area");
    //         const navigate = useNavigate();
    return (
        <>
         <Helmet>
                <title>
                    Cable Termination Tools & Cable Lugs UAE | Al Ibtekar
                </title>

                <meta
                    name="description"
                    content="Al Ibtekar supplies professional cable termination tools, cable cutting and stripping tools, crimping tools, cable lugs, terminals, ferrules and connectors for reliable cable installation across the UAE."
                />

                <meta
                    name="keywords"
                    content="cable termination tools UAE, cable lugs UAE, cable terminals UAE, crimping tools UAE, cable cutting tools UAE, cable stripping tools UAE, hydraulic crimping tools UAE, ferrules UAE, cable connectors UAE, cable termination equipment UAE, Cembre cable tools UAE, YK Electric cable tools UAE"
                />

                <meta
                    name="robots"
                    content="index, follow"
                />

                <link
                    rel="canonical"
                    href="https://saig.me/TerminationTools"
                />

                {/* Open Graph */}
                <meta
                    property="og:title"
                    content="Cable Termination Tools & Cable Lugs UAE | Al Ibtekar"
                />

                <meta
                    property="og:description"
                    content="Explore cable cutting, stripping and crimping tools, cable lugs, terminals, ferrules, connectors and professional termination equipment from Al Ibtekar UAE."
                />

                <meta
                    property="og:url"
                    content="https://saig.me/TerminationTools"
                />

                <meta
                    property="og:type"
                    content="website"
                />

                <meta
                    property="og:site_name"
                    content="Al Ibtekar"
                />

                {/* Twitter */}
                <meta
                    name="twitter:card"
                    content="summary_large_image"
                />

                <meta
                    name="twitter:title"
                    content="Cable Termination Tools & Cable Lugs UAE | Al Ibtekar"
                />

                <meta
                    name="twitter:description"
                    content="Professional cable termination tools, cable lugs, terminals, crimping tools, cutting tools and connectors for industrial cable installations in the UAE."
                />
            </Helmet>
            <div className='newbanner-about newbanner-about3'>
                <div className="max-w-[1440px] w-full mx-auto lg:px-[50px] px-[20px]">
                    <h6 className="font-[500] font-kanit lg:text-[60px] text-[30px] lg:leading-[90px] leading-[40px] text-[#FFFFFF] lg:pb-[14px] pb-[4px]">Cable Termination & Tools</h6>
                    <p className="lg:max-w-[582px] max-w-[250px] w-full font-[300] font-inter lg:text-[20px] text-[12px] lg:leading-[30px] leading-[16px] text-[#FFFFFF]">Precision tools and kits for fast, reliable cable terminations.
                    </p>
                </div>
            </div>



             <div className='newbg'>

               <div className='max-w-[1440px] w-full mx-auto lg:px-[50px] px-[20px] overflow-hidden allheader mb-[20px]'>

<h2>Cable Termination & Tools</h2>
  <div className='line'></div>
                         <h3 className='text-left mb-[20px]'>Along with the cable supplies we ensure that our customers have an access to a professional range of precise tools to execute the cuts, stripping and crimping, along with a properly sized and high-performance cable lugs and terminals. A wide range of products are available from Cembre & YK Electric manufactured range, to ensure a strong and secure termination with the cables in compliance with IEC 61238-1 suitable for conductor range 1.5-1000 sq. mm</h3>


               </div>
               </div>

            <div className='detail-div max-w-[1440px] w-full mx-auto lg:px-[50px] px-[20px] pb-[0px]'>

                <div className='detail-div-left'>

                    <div className='main-img'>

                        <img src='/assets/newterm.png' alt='s'  className='ln-img3'/>
                    </div>


                </div>

          <div className='detail-div-right'>
<ul className="mt-4 grid grid-cols-1 gap-1">
  {[
    "Cable Cutting Tools – Mechanical, Manual & Battery Operated",
    "Mechanical Cable & Wire Stripping Tools – Various Cable Types & Sizes",
    "Crimping Tools – Mechanical, Manual & Battery Operated Hydraulic",
    "Cable Lugs – One-Hole, Two-Hole, Four-Hole & Blank",
    "Non-Insulated Cable Lugs – Ring, Pin, Fork, Ferrule & Bi-Metallic",
    "Pre-Insulated Terminals – Ring, Pin, Fork, Bootlace & Butt Connectors",
    "Ferrules & Through Connectors – Reducing Link & Two-Way",
    "Sleeve Connectors – Earthing Network C & H Shaped",
    "Professional Tools – Scissors, Screwdrivers, Pliers, Spanners & Tool Holders",
    "Measuring Instruments – Multimeter, Measuring Tapes & Spirit Levels",
    "Hole Making Accessories – Punch, Conical Stepped & Drill Bits"
  ].map((item, i) => {

    // split on first dash ( - OR – )
    const match = item.match(/^([^–-]+)[–-]\s*(.*)$/);

    const title = match ? match[1] : item;
    const desc = match ? match[2] : "";

    return (
      <li
        key={i}
        className="flex items-start gap-3 rounded-lg bg-white px-4 transition"
      >
        <span className="mt-1 text-[#e09e0f] text-sm font-semibold">●</span>

        <span className="text-[18px] leading-relaxed text-left aplus">
          <span className="text-black font-semibold" style={{fontWeight:'500'}}>{title}</span>
          {desc && <span className="text-gray-700"> – {desc}</span>}
        </span>
      </li>
    );
  })}
</ul>

</div>

            </div>
            <div className='newbg'>

               <div className='max-w-[1440px] w-full mx-auto lg:px-[50px] px-[20px] overflow-hidden allheader mb-[20px]'>

                         <h3 className='text-left mb-[20px]'>The tools can be bought as a standalone article or it's available in an easy to organise and carry tool holders, bag kit, case, trolley, chest etc. Customisation of bag kit, case and chest are available on request. Kindly contact our representative to discuss the requirements.
<br/><br/>For free demo and hands on to the lugs, terminals, tool(s) - simply request on our website home page or dial +971 54 263 0184</h3>

<Link to="/product">
                       <button className="backbtn mt-6">
                         Back To Products
                       </button>
                     </Link>

               </div>
               </div>

       
        </>
    )
}

export default TerminationTools